import { Injectable, inject, signal } from '@angular/core';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private readonly _tokenService = inject(TokenService);

  private readonly _forceTestMode = signal(false);

  userRoles = signal<string[]>([]);

  initRoles() {
    if (this._forceTestMode()) {
      this.justReadRole();
      return;
    }

    const token = this._tokenService.getToken();

    if (!token) {
      this.userRoles.set([]);
      return;
    }

    try {
      const payload = this._tokenService.parseJwt(token);
      const rolesFromPayload = payload?.roles ?? [];
      if (Array.isArray(rolesFromPayload) && rolesFromPayload.length > 0) {
        this.userRoles.set([...rolesFromPayload]);
      } else {
        this.userRoles.set([]);
      }
    } catch (error) {
      this.userRoles.set([]);
      console.log(error);
    }
  }

  hasRole(role: string): boolean {
    return this.userRoles().includes(role);
  }

  hasAnyRole(roles: string[]): boolean {
    return this.userRoles().some((role) => roles.includes(role));
  }

  hasAllRoles(roles: string[]): boolean {
    return roles.every((role) => this.userRoles().includes(role));
  }

  clearRoles() {
    this.userRoles.set([]);
  }

  justReadRole() {
    this.userRoles.set(['BulkExport.Read']);
  }

  enableTestMode() {
    this._forceTestMode.set(true);
    this.justReadRole();
  }

  disableTestMode() {
    this._forceTestMode.set(false);
    this.initRoles();
  }
}
